import { ReactNode } from 'react'
import cx from 'classnames'
import styles from './SourceBadge.module.css'

/** 시안 `.src` + `.have/.new/.ff` 이식. 데이터 출처(기존 API/신규/FF) 배지. */
export type SourceBadgeProps = {
  tone: 'have' | 'new' | 'ff'
  children: ReactNode
}

export const SourceBadge = ({ tone, children }: SourceBadgeProps): JSX.Element => (
  <span className={cx(styles.src, styles[tone])}>{children}</span>
)
